import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import BlogPortableText from "./BlogPortableText";
import { Post } from "../../lib/sanity/types";
import { Link as RouterLink } from "react-router-dom";
import formatDate from "../../helpers/formatDate";
import getImageUrl from "../../helpers/getImageUrl";
import { memo } from "react";
import formatReadingTime from "../../helpers/formatReadingTime";

interface BlogCardProps {
  displayedPosts: Post[];
}

const BlogCards: React.FC<BlogCardProps> = ({ displayedPosts }) => {
  return (
    <Grid container spacing={3} justifyContent="center">
      {displayedPosts.map((post) => (
        <Grid key={`${post._id}-${post.slug}`} size={{ xs: 12, sm: 6, md: 4 }}>
          <Card
            sx={{
              bgcolor: "#1d2939",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "none",
              },
            }}
            component={RouterLink}
            to={`/blog/${post.slug}`}
          >
            <CardMedia
              component="img"
              src={getImageUrl(post)}
              alt="Blog post"
              sx={{
                width: "100%",
                aspectRatio: "16 / 9",
                objectFit: "cover",
                objectPosition: "center 15%",
                display: "block",
              }}
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
                sx={{ mb: 1.5 }}
              >
                <Typography
                  variant="caption"
                  sx={{ color: "rgba(255,255,255,0.6)" }}
                >
                  {formatDate(post.publishedAt)}
                  {post.readingTime &&
                    ` | ${formatReadingTime(post.readingTime)} read`}
                </Typography>
                {post.category?.title && (
                  <Chip
                    size="small"
                    label={post.category?.title}
                    sx={{
                      mb: 1.5,
                      bgcolor: "primary.main",
                      color: "#fff",
                      textTransform: "capitalize",
                    }}
                  />
                )}
              </Stack>
              <Typography
                variant="h6"
                component="h2"
                sx={{
                  color: "#fff",
                  mb: 1,
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                  overflow: "hidden",
                  fontSize: "18px",
                }}
              >
                {post.title}
              </Typography>

              {post.shortDescription && (
                <Box
                  sx={{
                    color: "rgba(255,255,255,0.7)",
                  }}
                >
                  <BlogPortableText value={post.shortDescription} />
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default memo(BlogCards);
